import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.input';

export default defineMessages({
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Search',
  },
});
